const card = ({ title, adresse }) => `
  <article class="card-reseller">
    <div>
      <h3>${title}</h3>
      ${adresse}
    </div>
  </article>
`;

class StoreLocator extends HTMLElement {
  map = undefined;
  center = { lat: 48.86, lng: 2.355 };
  stores = [];
  markers = [];
  zoom = 14;

  constructor() {
    super();

    this.items = [...this.querySelector('.js-store-locatore-items').children];
    this.$map = this.querySelector('.js-store-locatore-map');

    if (this.items.length < 2) {
      this.zoom = 10;

      const lat = parseFloat(this.items[0].getAttribute('data-latitude'));
      const lng = parseFloat(this.items[0].getAttribute('data-longitude'));

      this.center = { lat, lng };
    }

    this.map = new google.maps.Map(this.$map, {
      center: this.center,
      zoom: this.zoom,
      disableDefaultUI: true,
    });

    const icon = {
      url: this.getAttribute('data-icon-url'),
      scaledSize: new google.maps.Size(45, 45),
    };

    this.items.forEach((item) => {
      this.stores.push({
        lat: parseFloat(item.getAttribute('data-latitude')),
        lng: parseFloat(item.getAttribute('data-longitude')),
        title: item.getAttribute('data-name'),
        adresse: item.getAttribute('data-address'),
        id: item.getAttribute('data-id'),
      });
    });

    const informations = [];

    for (var i = 0; i < this.stores.length; i++) {
      const store = this.stores[i];
      const { title, lat, lng, id } = store;

      const infowindow = new google.maps.InfoWindow({
        content: card(store),
        ariaLabel: title,
      });

      const marker = new google.maps.Marker({
        position: { lat, lng },
        icon,
        map: this.map,
        zIndex: 1,
        title,
        id,
      });

      marker.addListener('click', () => {
        informations.forEach((info) => {
          info.set('marker', null);
          info.close();
        });
        informations.length = 0;
        infowindow.open({ map: marker.get('map'), anchor: marker });
        informations.push(infowindow);
      });

      this.markers.push(marker);
    }

    this.map.addListener('dragend', this.updateStores.bind(this));
    this.map.addListener('idle', this.updateStores.bind(this));

    var $input = this.querySelector('input[name="search"]');
    var searchBox = new google.maps.places.SearchBox($input);

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();

      if (places.length === 0) {
        return;
      }

      const bounds = new google.maps.LatLngBounds();
      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          console.log('Returned place contains no geometry');
          return;
        }
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.map.fitBounds(bounds);
    });
  }

  updateStores() {
    const bounds = this.map.getBounds();

    for (let i = 0; i < this.markers.length; i++) {
      const marker = this.markers[i];
      const $item = this.querySelector(`#reseller-${marker.id}`);

      if (bounds.contains(marker.getPosition()) === true) {
        $item.style.setProperty('display', 'block');
        $item.classList.add('active');
      } else {
        $item.style.setProperty('display', 'none');
        $item.classList.remove('active');
      }
    }
  }

  //   move_popin() {}
  //   resize() {}
}

window.initMap = () => {
  if (!customElements.get('store-locator')) {
    customElements.define('store-locator', StoreLocator);
    console.log('YO');
  }
};
